import { CaseSlideThumbnailData, Procedure, ProcedureResponse } from 'interfaces/procedure';
import { Slide } from 'interfaces/slide';
import { stringify } from 'qs';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';
import { CasesParams } from 'utils/useCasesParams/types';
import { toProceduresQueryString } from 'utils/useEncodedFilters/proceduresJobFilters';
import { SlideUpdate } from './slides';
import { CaseUpdate } from './study';

export const getProcedures = (queryParams: string, signal?: AbortSignal) => {
  return apiRequestHandlerPromise<ProcedureResponse>({
    url: `procedures?${toProceduresQueryString(queryParams)}`,
    method: 'GET',
    signal,
  });
};

export const approveProcedure = (caseId: number) => {
  return apiRequestHandlerPromise({
    url: `procedures/${caseId}/approve`,
    method: 'PATCH',
  });
};

export const unapproveProcedure = (caseId: number) => {
  return apiRequestHandlerPromise({
    url: `procedures/${caseId}/unapprove`,
    method: 'PATCH',
  });
};

export const getProcedureIds = (queryParams: string, caseId?: number, signal?: AbortSignal) => {
  // 'Boolean(caseId)' is for scenarios that caseId is null (isNaN(null) is false)
  const hasCaseId = Boolean(caseId) && !isNaN(caseId);
  return apiRequestHandlerPromise<number[]>({
    url: `procedures/ids?${toProceduresQueryString(queryParams)}`,
    method: 'GET',
    data: hasCaseId ? stringify({ procedure_id: caseId }) : undefined,
    signal,
  });
};

export const getCaseSlideThumbnailsData = (casesParams: CasesParams, signal?: AbortSignal) => {
  return apiRequestHandlerPromise<CaseSlideThumbnailData[]>({
    url: `procedures/slide_thumbnails.get`,
    method: 'POST',
    data: JSON.stringify(casesParams),
    signal,
  });
};

export const bulkUpdateProcedures = (
  data: {
    procedureUpdates: Partial<CaseUpdate>;
  } & CasesParams
) => {
  return apiRequestHandlerPromise<Procedure[]>({
    url: `procedures/bulk_update`,
    method: 'POST',
    data: JSON.stringify(data),
  });
};

export const bulkUpdateProcedureSlides = (
  data: {
    slideUpdates: Partial<SlideUpdate>;
  } & CasesParams
) => {
  return apiRequestHandlerPromise<Slide[]>({
    url: `procedures/slides/bulk_update`,
    method: 'POST',
    data: JSON.stringify(data),
  });
};
